import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, Fragment as _Fragment, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-28698aac")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_confirm_dialog = _resolveComponent("confirm-dialog")
  const _component_delete_confirm_dialog = _resolveComponent("delete-confirm-dialog")
  const _component_DefaultIcon = _resolveComponent("DefaultIcon")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.enableConfirmDialog === true)
      ? (_openBlock(), _createBlock(_component_confirm_dialog, {
          key: 0,
          onConfirm: _ctx.confirmDialog,
          ref: "confirmRef",
          "show-button": "false",
          title: _ctx.confirmTitle,
          description: _ctx.confirmDescription
        }, null, 8, ["onConfirm", "title", "description"]))
      : _createCommentVNode("", true),
    (_ctx.enableDeleteDialog)
      ? (_openBlock(), _createBlock(_component_delete_confirm_dialog, {
          key: 1,
          onConfirm: _ctx.deleteConfirmDialog,
          ref: "deleteConfirmRef",
          "show-button": "false",
          title: _ctx.deleteConfirmTitle,
          description: _ctx.deleteConfirmDescription
        }, null, 8, ["onConfirm", "title", "description"]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode("a", {
      class: ['m-1 text-white dark:text-gray-700 hover:bg-bp', 'flex', 'm-1 transform  hover:text-white hover:dark:text-gray-700 px-3 font-medium' + _ctx.itemWidth + ' ' + _ctx.itemHeight + ' ' + _ctx.cssClass + ' ' + _ctx.textHeight],
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleConfirmDialog && _ctx.toggleConfirmDialog(...args)))
    }, [
      (_ctx.itemIconPre.length > 0)
        ? (_openBlock(), _createBlock(_component_DefaultIcon, {
            key: 0,
            icon: _ctx.itemIconPre,
            class: ""
          }, null, 8, ["icon"]))
        : _createCommentVNode("", true),
      _createTextVNode(" " + _toDisplayString(_ctx.itemText) + " ", 1),
      (_ctx.itemIconAfter.length > 0)
        ? (_openBlock(), _createBlock(_component_DefaultIcon, {
            key: 1,
            icon: _ctx.itemIconAfter,
            class: ""
          }, null, 8, ["icon"]))
        : _createCommentVNode("", true)
    ], 2), [
      [_vShow, _ctx.enableConfirmDialog && _ctx.showItem]
    ]),
    _withDirectives(_createVNode("a", {
      class: ['m-1 text-white dark:text-gray-700 hover:bg-bp', 'flex', 'm-1 transform  hover:text-white hover:dark:text-gray-700 px-3 font-medium' + _ctx.itemWidth + ' ' + _ctx.itemHeight + ' ' + _ctx.cssClass + ' ' + _ctx.textHeight],
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleDeleteConfirmDialog && _ctx.toggleDeleteConfirmDialog(...args)))
    }, [
      (_ctx.itemIconPre.length > 0)
        ? (_openBlock(), _createBlock(_component_DefaultIcon, {
            key: 0,
            icon: _ctx.itemIconPre,
            class: ""
          }, null, 8, ["icon"]))
        : _createCommentVNode("", true),
      _createTextVNode(" " + _toDisplayString(_ctx.itemText) + " ", 1),
      (_ctx.itemIconAfter.length > 0)
        ? (_openBlock(), _createBlock(_component_DefaultIcon, {
            key: 1,
            icon: _ctx.itemIconAfter,
            class: ""
          }, null, 8, ["icon"]))
        : _createCommentVNode("", true)
    ], 2), [
      [_vShow, _ctx.enableDeleteDialog && _ctx.showItem]
    ]),
    _withDirectives(_createVNode(_component_router_link, {
      class: [_ctx.activeRoute === true ? 'm-1 bg-bp text-md lg:text-xl text-white dark:text-gray-700 p-2 rounded-3xl font-bolt' : ' text-md lg:text-xl rounded-3xl p-2 bg-bp-text dark:text-gray-400 hover:bg-bp', 'flex', 'm-1 transform hover:text-white dark:hover:text-gray-700 px-3 font-medium text-center items-center text-center ' + _ctx.itemWidth + ' ' + _ctx.itemHeight + ' ' + _ctx.cssClass + ' ' + _ctx.textHeight],
      to: _ctx.redirectLink
    }, {
      default: _withId(() => [
        (_ctx.itemIconPre.length > 0)
          ? (_openBlock(), _createBlock(_component_DefaultIcon, {
              key: 0,
              "css-class": "mr-2",
              "icon-height": "h-5",
              "icon-width": "w-5",
              icon: _ctx.itemIconPre,
              class: ""
            }, null, 8, ["icon"]))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(_ctx.itemText) + " ", 1),
        (_ctx.itemIconAfter.length > 0)
          ? (_openBlock(), _createBlock(_component_DefaultIcon, {
              key: 1,
              icon: _ctx.itemIconAfter,
              class: ""
            }, null, 8, ["icon"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["class", "to"]), [
      [_vShow, _ctx.enableDeleteDialog === false && _ctx.enableConfirmDialog === false && _ctx.showItem]
    ])
  ], 64))
})